import React from 'react';
import { Grid, Typography } from '@mui/material';
import { ILTRestrictionSectionProps } from 'app/models/Orders/OrderDetails';
import { useStyles } from './OrderDetailsReportStyles';
import { useTranslation } from 'react-i18next';
import { AMNDivisionType } from 'app/models/enums/AMNDivisionType';

type LTRestrictionProps = {
  ltrestrictionDetails: ILTRestrictionSectionProps;
};
export const OrderDetailsReportLTRestrictions = (props: LTRestrictionProps) => {
  const { classes } = useStyles();
  const ltrDetails = props.ltrestrictionDetails;
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.ltrestrictionsSection.facilitycontractradiusrule')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {ltrDetails.radiusRule}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.ltrestrictionsSection.travelerpermanentaddresswithin')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.dataCell}`}>
          {ltrDetails.permAddressWithIn}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.ltrestrictionsSection.billrateagreement')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {ltrDetails.billRateAgreement}
        </Grid>
        <Grid xs={6} md={2} className={`${classes.alternativeLabelCell}`}>
          <Typography>{t('order.orderReportDetails.ltrestrictionsSection.travelerbenefitresults')}:</Typography>
        </Grid>
        <Grid xs={6} md={4} className={`${classes.alternativeDataCell}`}>
          {ltrDetails.benefitResult}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={2} className={`${classes.labelCell}`}>
          <Typography>{t('order.orderReportDetails.ltrestrictionsSection.notes')}:</Typography>
        </Grid>
        <Grid xs={6} md={10} className={`${classes.dataCell}`}>
          {ltrDetails.restrictionNotes}
        </Grid>
      </Grid>
      {ltrDetails.amnDivisionTypeId == AMNDivisionType.Allied && (
        <Grid container>
          <Grid container className={`${classes.subheadlabel}`}>
            {t('order.orderReportDetails.ltrestrictionsSection.billinformation')}
          </Grid>
          <Grid container>
            <Grid container className={`${classes.gridLabel}`}>
              <Grid xs={12} md={1}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.skillset')}</Typography>
              </Grid>
              <Grid xs={12} md={1}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.shift')}</Typography>
              </Grid>
              <Grid xs={12} md={1}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.regular')}</Typography>
              </Grid>
              <Grid xs={12} md={1.5}>
                <Grid container>
                  <Grid xs={12} md={6}>
                    <Typography>{t('order.orderReportDetails.ltrestrictionsSection.ot')}</Typography>
                  </Grid>
                  <Grid xs={12} md={6}>
                    <Typography>{t('order.orderReportDetails.ltrestrictionsSection.additionalot')}</Typography>
                  </Grid>
                </Grid>
              </Grid>

              <Grid xs={12} md={1.5} className={`${classes.gridrightAlign}`}>
                <Grid container>
                  <Grid xs={12} md={4}>
                    <Typography>{t('order.orderReportDetails.ltrestrictionsSection.dt')}</Typography>
                  </Grid>
                  <Grid xs={12} md={2}></Grid>
                  <Grid xs={12} md={6}>
                    <Typography>{t('order.orderReportDetails.ltrestrictionsSection.additionaldt')}</Typography>
                  </Grid>
                </Grid>
              </Grid>
              <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.holiday')}</Typography>
              </Grid>
              <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.oncall')}</Typography>
              </Grid>
              <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.callback')}</Typography>
              </Grid>
              <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.additionalcallback')}</Typography>
              </Grid>
              <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.chargeadditional')}</Typography>
              </Grid>
              <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                <Typography>{t('order.orderReportDetails.ltrestrictionsSection.orientation')}</Typography>
              </Grid>
            </Grid>
            {ltrDetails.facilityBillrate.slice().map((row, index) => (
              <Grid container className={`${classes.gridData}`}>
                <Grid xs={12} md={1}>
                  {row.skillset}
                </Grid>
                <Grid xs={12} md={1}>
                  {row.descShift}
                </Grid>
                <Grid xs={12} md={1}>
                  {row.regularRate}
                </Grid>
                <Grid xs={12} md={1.5}>
                  <Grid container>
                    <Grid xs={12} md={6}>
                      {row.overtimeFactor}
                    </Grid>
                    <Grid xs={12} md={6}>
                      {row.overtimeRate}
                    </Grid>
                  </Grid>
                </Grid>
                <Grid xs={12} md={1.5} className={`${classes.gridrightAlign}`}>
                  <Grid container>
                    <Grid xs={12} md={4}>
                      {row.doubletimeFactor}
                    </Grid>
                    <Grid xs={12} md={2}></Grid>
                    <Grid xs={12} md={6}>
                      {row.doubleTimeRate}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                  {row.holidayTotal}
                </Grid>
                <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                  {row.onCallRate}
                </Grid>
                <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                  {row.callBackFactor}
                </Grid>
                <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                  {row.callBackRate}
                </Grid>
                <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                  {row.chargePremium}
                </Grid>
                <Grid xs={12} md={1} className={`${classes.gridrightAlign}`}>
                  {row.orientationFactor}
                </Grid>
              </Grid>
            ))}
          </Grid>

          <Grid container>
            <Grid xs={6} md={1} className={`${classes.labelCell}`}>
              <Typography>{t('order.orderReportDetails.ltrestrictionsSection.notes')}:</Typography>
            </Grid>
            <Grid xs={6} md={11} className={`${classes.dataCell}`}></Grid>
          </Grid>
        </Grid>
      )}

      <Grid container className={classes.headlabel}>
        <Grid xs={6} md={6}>
          {t('order.orderReportDetails.ltrestrictionsSection.shiftdifferentials')}
        </Grid>
      </Grid>

      <Grid container>
        <Grid xs={6} md={8}>
          <Grid container className={`${classes.gridLabel}`}>
            <Grid item xs={6} md={3}>
              <Typography>{t('order.orderReportDetails.ltrestrictionsSection.skillset')}</Typography>
            </Grid>
            <Grid item xs={6} md={3}>
              <Typography>{t('order.orderReportDetails.ltrestrictionsSection.description')}</Typography>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography>{t('order.orderReportDetails.ltrestrictionsSection.amount')}</Typography>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography>{t('order.orderReportDetails.ltrestrictionsSection.start')}</Typography>
            </Grid>
            <Grid item xs={6} md={2}>
              <Typography>{t('order.orderReportDetails.ltrestrictionsSection.end')}</Typography>
            </Grid>
          </Grid>
          {ltrDetails.facilityBRShiftDifferentials.map((row, index) => (
            <Grid container className={`${classes.gridData}`} key={index}>
              <Grid item xs={6} md={3}>
                {row.skillset}
              </Grid>
              <Grid item xs={6} md={3}>
                {row.shiftDifferentialDescType}
              </Grid>
              <Grid item xs={6} md={2}>
                {row.amount}
              </Grid>
              <Grid item xs={6} md={2}>
                {row.startTime}
              </Grid>
              <Grid item xs={6} md={2}>
                {row.endTime}
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  );
};
